import React from "react";
import {connect} from "react-redux";
import {Dialog, CircularProgress} from "@material-ui/core";
import {IStore} from "../store/reducers";
import actionTypes from "../store/actionTypes";
import {Map, Polygon, TileLayer, ZoomControl, Marker} from "react-leaflet";
import L, {LatLngTuple} from "leaflet";
import {IMapas, INotificacion} from "../types";
import axios from "axios";
import config from "../config.json";
import StationIcon from "../icons/PNGs/station.png"


const station_icon = new L.Icon({
    iconUrl: StationIcon,
    iconRetinaUrl: StationIcon,
    iconSize: [28, 48],
    iconAnchor: [14, 48]
})


interface IProps {
    close(): void
    setZoom(zoom: number): void
    setCenter(center: LatLngTuple): void
    notify(notification: INotificacion): void
    setComunidad(comunidad: string): void
    setProvincia(provincia: string): void
    setEstacion(estacion: string): void
    open: boolean
    zoom: number
    center: LatLngTuple
}

interface IState {
    estaciones: Record<string, Record<string, number>>
    filtros2campos: Record<string, string>
}

class Estaciones extends React.Component<IProps, IState>{
    state:IState = {
        estaciones: {},
        filtros2campos: {}
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (!this.props.open && nextProps.open) {
            axios.get(config.url+'/static/estaciones_info.json')
                .then((res) => {
                    this.setState({estaciones: res.data})
                })
                .catch(() => {
                    this.props.notify({message: "Error cargando estaciones meteorológicas", variant: 'error'})
                    setTimeout(() => this.props.close(), 2000)
                })
            axios.get(config.url+'/static/estaciones_siar.json')
                .then((res) => {
                    this.setState({filtros2campos: res.data})
                })
                .catch(() => {
                    this.props.notify({message: "Error cargando estaciones meteorológicas", variant: 'error'})
                    setTimeout(() => this.props.close(), 2000)
                })
        }
        return true
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={() => this.props.close()}
                maxWidth={false}
                PaperProps={{
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        height: '80vh',
                        width: '60vw'
                    }
            }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        height: "100%",
                        width: "100%",
                    }}
                >
                    <Map
                        center={this.props.center}
                        zoom={this.props.zoom}
                        maxZoom={20}
                        style={{
                            width: '100%',
                            height: '100%',
                            zIndex: 1,
                            cursor: "pointer"
                        }}
                        onmoveend={(e) => {
                            this.props.setZoom(e.target.getZoom())
                            this.props.setCenter([e.target.getCenter().lat,e.target.getCenter().lng])
                        }}
                        zoomControl={false}
                    >
                        <TileLayer url={'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'}/>
                        <ZoomControl
                            position={'topright'}
                        />

                        {Object.keys(this.state.estaciones).map(id =>
                            <Marker
                                key={id}
                                draggable={false}
                                position={[this.state.estaciones[id]["latitud"], this.state.estaciones[id]["longitud"]] as LatLngTuple}
                                icon={station_icon}
                                onclick={() => {
                                    this.props.setComunidad(this.state.filtros2campos[this.state.estaciones[id]["filtros"]].split(",")[0])
                                    this.props.setProvincia(this.state.filtros2campos[this.state.estaciones[id]["filtros"]].split(",")[1])
                                    this.props.setEstacion(this.state.filtros2campos[this.state.estaciones[id]["filtros"]].split(",")[2])
                                    setTimeout(() => this.props.close(), 500)
                                }}
                            />
                        )}

                    </Map>
                </div>

            </Dialog>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    open: state.navegacion.dialogs.estaciones,
    zoom: state.principal.zoom,
    center: state.principal.center
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    close: () => dispatch({type: "open-estaciones", callback: false}),
    setZoom: (zoom: number) => dispatch({type: "set-principal-zoom", zoom}),
    setCenter: (center: LatLngTuple) => dispatch({type: "set-principal-center", center}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    setComunidad: (comunidad: string) => dispatch({type: "set-crear-parcela-comunidad", comunidad}),
    setProvincia: (provincia: string) => dispatch({type: "set-crear-parcela-provincia", provincia}),
    setEstacion: (estacion: string) => dispatch({type: "set-crear-parcela-estacion", estacion})
});

export default connect(mapStateToProps, mapDispatchToProps)(Estaciones);
